import * as React from "react";
import { CSSObject, styled, Theme } from "@mui/material/styles";
import List from "@mui/material/List";
import MuiDrawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import { useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";
import { AdminLeftMenu } from "../compenents/Layout/AdminLeftMenu";
import { CustomerLeftMenu } from "../compenents/Layout/CustomerLeftMenu";
import { DealerLeftMenu } from "../compenents/Layout/DealerLeftMenu";
export interface AppLeftMenuProps {
  setOpen: any;
  open: any;
}
export interface LeftMenuProps {
  dmsType: number;
}

const drawerWidth = 240;
const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.enteringScreen * 2.5,
  }),
  overflowX: "hidden",
  position: "fixed",
  zIndex: theme.zIndex.drawer + 1,
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.enteringScreen * 2.5,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  position: "fixed",
  zIndex: theme.zIndex.drawer + 1,
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const AppLeftMenu: React.FunctionComponent<LeftMenuProps> = ({
  dmsType,
}) => {
  const { userType } = useSelector((state: AppState) => state.authReducer);
  const [open, setOpen] = React.useState(false);

  const hideShowTeamSupport = (show: boolean) => {
    if (dmsType === 0) {
      // Hide/Show the team support if present
      let teamSupportWidget = document.getElementById(
        "designstudio-button"
      ) as HTMLElement;
      if (teamSupportWidget)
        teamSupportWidget.style.display = !show ? "none" : "unset";
    }
  };

  const handleMouseEnter = () => {
    setOpen(true);
    hideShowTeamSupport(false);
  };
  const handleMouseLeave = () => {
    setOpen(false);
    hideShowTeamSupport(true);
  };
  return (
    <>
      <Drawer
        sx={{
          width: drawerWidth,
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            bgcolor: "#1e1e40",
            color: "#FFFFFF",
          },
        }}
        variant="permanent"
        anchor="left"
        open={open}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Divider sx={{ bgcolor: "white", mt: 8 }} />
        <List sx={{ mt: 1 }}>
          {userType === "Admin" ? (
            <AdminLeftMenu />
          ) : userType === "Customer" || userType === "PortalCustomer" ? (
            <CustomerLeftMenu />
          ) : userType === "User" ? (
            <>
              <DealerLeftMenu handleCloseSidebar={handleMouseLeave}/>
            </>
          ) : (
            ""
          )}
        </List>
        <Divider sx={{ bgcolor: "white" }} />
      </Drawer>
    </>
  );
};
